import ApiResponse from "../models/ApiResponse";
import Api from "./Api";

export namespace UserActivity {
  export type GroupFilter = TestRequestRaw.Schemas.Group;
  export type LabFilter = TestRequestRaw.Schemas.CSCLaboratory;
  export type PageIndex = number;
  export type PageSize = number;
  export type RoleFilter = TestRequestRaw.Schemas.Role;
  export type SortColumn = "EMAIL_ADDRESS" | "LAST_LOGIN" | "NAME";
  export type SortDirection = "ASC" | "DESC";
  export type SearchTerms = string[];
  export type SearchResultPagedResponse = Required<TestRequestRaw.Schemas.PagedResponseUserActivitySearchResult>;
  export type SearchResult = Required<TestRequestRaw.Schemas.UserActivitySearchResult>;
}

export type FetchUserActivitiesQuery = {
  groupFilter?: UserActivity.GroupFilter;
  labFilter?: UserActivity.LabFilter;
  pageIndex?: UserActivity.PageIndex;
  pageSize?: UserActivity.PageSize;
  roleFilter?: UserActivity.RoleFilter;
  sortColumn?: UserActivity.SortColumn;
  sortDirection?: UserActivity.SortDirection;
  terms?: UserActivity.SearchTerms;
};

class UserActivityApi {
  constructor(private api: Api) {}

  public fetchUserActivities(query: FetchUserActivitiesQuery): ApiResponse<UserActivity.SearchResultPagedResponse> {
    const { terms, ...restQuery } = query;
    const initParams: string[][] = [];
    Object.entries(restQuery).forEach(([key, val]) => {
      if (val !== undefined) {
        initParams.push([key, String(val)]);
      }
    });
    const searchParams = new URLSearchParams(initParams);
    if (terms) {
      terms.forEach((term) => searchParams.append("terms", term));
    }
    return this.api.get(`/test-request/v2/user-activity?${searchParams}`);
  }
}

export default UserActivityApi;
